module.exports = __webpack_public_path__ + "img/up_sort.ad61310a.svg";